<template>
  <AuthenticatedLayout>
    <PageHeader title="Users" />
    <user-data-table />
  </AuthenticatedLayout>
</template>

<script lang="ts" setup>
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import UserDataTable from "@/components/DataTables/UserDataTable.vue";
import PageHeader from "@/components/PageHeader.vue";
</script>

<style>

</style>
